import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "card-title d-flex flex-column col" }
const _hoisted_5 = { class: "fs-2hx fw-bold text-dark me-2 lh-1 ls-n2" }
const _hoisted_6 = { class: "text-gray-400 pt-1 fw-semibold fs-6" }
const _hoisted_7 = { class: "card-title d-flex flex-column col" }
const _hoisted_8 = { class: "fs-2hx fw-bold text-dark me-2 lh-1 ls-n2" }
const _hoisted_9 = { class: "text-gray-400 pt-1 fw-semibold fs-6" }
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "card-body py-3" }
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle px-2 fs-3 text-danger" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_download_excel = _resolveComponent("download-excel")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.countPeticiones), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(
                "tabla.serviciosColectivosSolicitadosListado.contador.solicitudes"
              )), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.countAprobados), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(
                "tabla.serviciosColectivosSolicitadosListado.contador.admisiones"
              )), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          style: {"width":"300px"},
          placeholder: _ctx.$t('tabla.buscador.placeholder')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_download_excel, {
          data: _ctx.serviciosListado,
          labels: _ctx.csvLabels,
          fields: _ctx.csvFields,
          name: _ctx.csvName
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_11, [
              _createElementVNode("i", {
                class: "fas fa-file-excel fs-3",
                title: 
                _ctx.$t('tabla.serviciosColectivosSolicitadosListado.boton.imprimir')
              
              }, null, 8, _hoisted_12)
            ])
          ]),
          _: 1
        }, 8, ["data", "labels", "fields", "name"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_table, {
        data: _ctx.serviciosListado,
        style: {"width":"100%"},
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t('tabla.serviciosColectivosSolicitadosListado.cabecera.fecha')
          ,
            prop: "fecha",
            formatter: _ctx.toLocaleDateString,
            sortable: "",
            width: "110"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", {
                "data-bs-toggle": "tooltip",
                title: _ctx.formatHour(scope.row.fecha)
              }, _toDisplayString(_ctx.formatLongDate(scope.row.fecha)), 9, _hoisted_14)
            ]),
            _: 1
          }, 8, ["label", "formatter"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t(
              'tabla.serviciosColectivosSolicitadosListado.cabecera.responsable'
            )
          ,
            prop: "responsable",
            sortable: "",
            "min-width": "150"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_router_link, {
                to: 
                scope.row.familiaId
                  ? `/listados/familias/${scope.row.familiaId}`
                  : `/solicitudes/familias/${scope.row.familiaFormularioId}`
              
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.responsable), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t('tabla.serviciosColectivosSolicitadosListado.cabecera.dni')
          ,
            prop: "dni",
            sortable: "",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_router_link, {
                to: 
                scope.row.familiaId
                  ? `/listados/familias/${scope.row.familiaId}`
                  : `/solicitudes/familias/${scope.row.familiaFormularioId}`
              
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.dni), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t(
              'tabla.serviciosColectivosSolicitadosListado.cabecera.estadoFamilia'
            )
          ,
            sortable: "",
            width: "140",
            "sort-method": _ctx.sortFamiliaEstado
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                class: "ml-2",
                type: 
                scope.row.familiaEstado == 'ADMITIDA'
                  ? 'success'
                  : scope.row.familiaEstado == 'NO_APTO'
                  ? 'error'
                  : 'warning'
              
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`estados.${scope.row.familiaEstado}`)), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }, 8, ["label", "sort-method"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t('tabla.serviciosColectivosSolicitadosListado.cabecera.menores')
          ,
            prop: "menoresNombres",
            sortable: "",
            "min-width": "150"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t(
              'tabla.serviciosColectivosSolicitadosListado.cabecera.fechaNacimiento'
            )
          ,
            prop: "fechaNacimientoDate",
            formatter: _ctx.toLocaleDateString,
            sortable: "",
            "min-width": "110"
          }, null, 8, ["label", "formatter"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t('tabla.serviciosColectivosSolicitadosListado.cabecera.telefono')
          ,
            prop: "telefono",
            sortable: "",
            width: "110"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t('tabla.serviciosColectivosSolicitadosListado.cabecera.email')
          ,
            prop: "email",
            sortable: "",
            "min-width": "150"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.profesionales.cabecera.estado'),
            sortable: "",
            "sort-method": _ctx.sortServicioEstado,
            width: "180",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_dropdown, { class: "me-3" }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        onClick: ($event: any) => (_ctx.onAprobar(scope.row)),
                        disabled: 
                      scope.row.estado === _ctx.FormularioEstado.incorporado ||
                      !scope.row.familiaAprobada
                    
                      }, {
                        default: _withCtx(() => [
                          (
                        !scope.row.familiaAprobada &&
                        !scope.row.familiaFormularioId
                      )
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                class: "box-item",
                                effect: "dark",
                                placement: "top-end",
                                content: 
                        _ctx.$t(
                          'tabla.serviciosColectivosSolicitadosListado.infoNoSePuedeAprobar'
                        )
                      ,
                                "raw-content": "",
                                width: "400"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              }, 8, ["content"]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("formularios.servicioDetalle.admitir.button")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: ($event: any) => (_ctx.pendiente(scope.row)),
                        disabled: scope.row.estado === _ctx.FormularioEstado.pendiente
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.pendiente.button")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: ($event: any) => (_ctx.listaDeEspera(scope.row)),
                        disabled: 
                      scope.row.estado === _ctx.FormularioEstado.listaDeEspera
                    
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.listaDeEspera.button")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: ($event: any) => (_ctx.rechazar(scope.row)),
                        divided: "",
                        disabled: scope.row.estado === _ctx.FormularioEstado.rechazado
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.rechazar.button")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: ($event: any) => (_ctx.realizadaPorError(scope.row)),
                        disabled: 
                      scope.row.estado === _ctx.FormularioEstado.realizadorPorError
                    
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.realizadoPorError.button")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: ($event: any) => (_ctx.admitidoNoUsaServicio(scope.row)),
                        disabled: 
                      scope.row.estado ===
                      _ctx.FormularioEstado.admitidoNoUsaServicio
                    
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.servicioDetalle.admitidoNoUsaServicio.button"
                      )), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    class: "ml-2",
                    type: 
                  scope.row.estado === _ctx.FormularioEstado.incorporado
                    ? 'success'
                    : scope.row.estado === _ctx.FormularioEstado.listaDeEspera
                    ? 'warning'
                    : [
                        _ctx.FormularioEstado.noApto,
                        _ctx.FormularioEstado.rechazado,
                        _ctx.FormularioEstado.realizadorPorError,
                        _ctx.FormularioEstado.admitidoNoUsaServicio,
                      ].includes(scope.row.estado)
                    ? 'danger'
                    : ''
                
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`formularios.estado.${scope.row.estado}`)) + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["label", "sort-method"]),
          _createVNode(_component_el_table_column, {
            width: "50",
            align: "center",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "text",
                onClick: ($event: any) => (_ctx.verSolicitud(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("tabla.serviciosColectivosSolicitadosListado.fila.ver")), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ]))
}